import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import _ from 'lodash';
import moment from 'moment';
import { NextDialTargetChanged } from './next-dial-target.actions';

export interface DialTarget {
   number: string;
   name?: string;
   subscriberId?: number;
}

export interface NextDialTargetStateModel {
   nextDialTarget: DialTarget;
   targetSetByBrickInstanceId: string;
   changedAt: moment.Moment;
}

@State<NextDialTargetStateModel>({
   name: 'nextDialTargetState',
   defaults: {
      nextDialTarget: null,
      targetSetByBrickInstanceId: null,
      changedAt: moment(),
   },
})
@Injectable()
export class NextDialTargetState {
   constructor() {}

   @Selector([NextDialTargetState])
   public static targetSetByBrickInstanceId(state: NextDialTargetStateModel): string {
      return state.targetSetByBrickInstanceId;
   }

   @Selector([NextDialTargetState])
   public static nextDialTarget(state: NextDialTargetStateModel): DialTarget {
      return state.nextDialTarget;
   }

   @Selector([NextDialTargetState.nextDialTarget])
   public static nextDialTargetNumber(dialTarget: DialTarget): string {
      return dialTarget?.number;
   }

   @Selector([NextDialTargetState])
   public static nextDialTargetChangedAt(state: NextDialTargetStateModel): moment.Moment {
      return state.changedAt;
   }

   @Action(NextDialTargetChanged)
   public nextDialTargetChanged(ctx: StateContext<NextDialTargetStateModel>, action: NextDialTargetChanged) {
      ctx.patchState({
         targetSetByBrickInstanceId: action.brickInstanceId,
         changedAt: moment(),
      });
      if (_.isString(action?.dialTarget)) {
         ctx.patchState({
            nextDialTarget: { number: action?.dialTarget?.trim() as string },
         });
      } else {
         ctx.patchState({
            nextDialTarget: !_.isEmpty(action?.dialTarget?.number?.trim()) ? (action?.dialTarget as DialTarget) : { number: '' },
         });
      }
   }
}
